import React from 'react'
import ajay from '../../pages/about/ee/ajay.png'
import Hero from './Hero'
import About from './About'
function Ajay () {
  return (
    <section className="container-fluid p-0">
        <Hero title="AJAY KUMAR SHINDHE" subtitle='"Ajay is a young and energetic video editor with fresh thoughts and a knack for quick turnaround times. He excels at crafting captivating video content, from dynamic edits for films and commercials to engaging reels for social media platforms. Always ready to assist on set, Ajay brings a creative and collaborative spirit to every project".' image={ajay}/>
        </section>
  )
}

export default Ajay 